<h2 mat-dialog-title>{{ 'task.cards.units' | blah }}</h2>
<mat-dialog-content>
    @if (!loading) {
    <div id="units-dashboard__container">
        <div id="charts">
            <div id="unitsSelection__container"
                class="dashboard__box">
                <p class="dashboard__box--header">{{ 'dashboard.unitsDashboard.units' | blah }}</p>
                <div id="unitsSelection__content">
                    <mat-form-field>
                        <mat-label>{{ 'dashboard.unitsDashboard.unitList' | blah }}</mat-label>
                        <mat-select [(value)]="selectedUnitList"
                            (selectionChange)="unitListChanges()"
                            [compareWith]="compareUnitLists">
                            <mat-option [value]="0">{{ 'default.all' | blah }}</mat-option>
                            @for (unitList of unitLists; track unitList) {
                            <mat-option [value]="unitList">{{unitList.Name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <hpo-input type="text"
                        placeholder="{{ 'dashboard.unitsDashboard.priceList' | blah }}"
                        [(value)]="selectedPriceListName"
                        [readonly]="true">
                    </hpo-input>
                </div>
            </div>
            <div id="totalChart__container"
                class="dashboard__box">
                <p class="dashboard__box--header">{{ 'dashboard.unitsDashboard.total' | blah }}</p>
                <div id="totalChart__content">
                    <div class="chart--labels">
                        @for (category of totalChartCategories; track category) {
                        <span class="chart--label">{{ 'dashboard.unitsDashboard.' + category | blah }}</span>
                        }
                    </div>
                    <kendo-chart>
                        <kendo-chart-area background="#efefef"
                            height="100">
                        </kendo-chart-area>
                        <kendo-chart-axis-defaults [majorGridLines]="{visible: false}"
                            [minorGridLines]="{visible: false}"
                            [line]="{width: 0}">
                        </kendo-chart-axis-defaults>
                        <kendo-chart-category-axis>
                            <kendo-chart-category-axis-item [labels]="{ visible: false }">
                            </kendo-chart-category-axis-item>
                        </kendo-chart-category-axis>
                        <kendo-chart-value-axis>
                            <kendo-chart-value-axis-item [labels]="{ visible: false }"
                                [min]="0">
                            </kendo-chart-value-axis-item>
                        </kendo-chart-value-axis>
                        <kendo-chart-series>
                            <kendo-chart-series-item type="column"
                                [data]="totalChartData"
                                field="value"
                                categoryField="category"
                                [labels]="{ visible: false }"
                                [gap]="0.1"
                                [spacing]="0">
                            </kendo-chart-series-item>
                        </kendo-chart-series>
                    </kendo-chart>
                    <div class="chart--labels">
                        @for (item of totalChartData; track item.category) {
                        <span class="chart--label">{{ item.value | number: '1.2-2' }} €</span>
                        }
                    </div>
                </div>
            </div>
            <div id="invoicing__container"
                class="dashboard__box">
                <p class="dashboard__box--header">{{ 'dashboard.unitsDashboard.invoicingForSupplied' | blah }}</p>
                <div class="invoicing__content">
                    <div class="categories">
                        @for (category of invoicedChartValues; track category.category) {
                        <div class="category__box"
                            [ngStyle]="{'border-color': category.color}">
                            <div class="title">{{ 'dashboard.unitsDashboard.' + category.category | blah }}</div>
                            <div class="values">
                                <span>{{ category.value | number: '1.2-2' }} €</span>
                                <span>{{ category.percent | number: '1.2-2' }}%</span>
                            </div>
                        </div>
                        }
                    </div>
                    <kendo-chart *ngIf="invoicedChartValues.length">
                        <ng-template kendoChartDonutCenterTemplate>
                            {{invoicedChartPercent}}%
                        </ng-template>
                        <kendo-chart-area background="#efefef"
                            height="140"
                            width="180">
                        </kendo-chart-area>
                        <kendo-chart-series>
                            <kendo-chart-series-item type="donut"
                                [data]="invoicedChartValues"
                                field="percent"
                                categoryField="category"
                                [holeSize]="34">
                            </kendo-chart-series-item>
                        </kendo-chart-series>
                        <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                    </kendo-chart>
                </div>

            </div>
        </div>
        <div id="units-table"
            *ngIf="!loading">
            <mat-table [dataSource]="units"
                multiTemplateDataRows>

                <!-- Group header -->
                <ng-container matColumnDef="groupHeader">
                    <mat-cell *matCellDef="let unit">
                        <div class="subheading--title heading-17"><span class="heading-17">{{ 'task.unit.' + unit.subheading | blah }}</span></div>
                        <div class="subheading__ordered"></div>
                        <div class="subheading__supplied"></div>
                        <div class="subheading__invoiced"></div>
                    </mat-cell>
                </ng-container>

                <!-- name column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let unit">
                        {{unit.Identifier}} {{unit.Name}} ({{unit.UnitOfMeasurement}})
                    </mat-cell>
                </ng-container>

                <!-- ordered column -->
                <ng-container matColumnDef="ordered">
                    <mat-header-cell *matHeaderCellDef>
                        <span class="unit-number-container ordered--title">{{ 'dashboard.unitsDashboard.Ordered' | blah }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let unit">
                        <span class="unit-number-container">{{ unit.OrderedAmount || 0 | number:'1.3-3' }}</span>
                    </mat-cell>
                </ng-container>

                <!-- supplied column -->
                <ng-container matColumnDef="supplied">
                    <mat-header-cell *matHeaderCellDef>
                        <span class="unit-number-container supplied--title">{{ 'dashboard.unitsDashboard.Supplied' | blah }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let unit">
                        <span class="unit-number-container">{{ unit.SuppliedAmount || 0 | number:'1.3-3' }}</span>
                    </mat-cell>
                </ng-container>

                <!-- invoiced column -->
                <ng-container matColumnDef="invoiced">
                    <mat-header-cell *matHeaderCellDef>
                        <span class="unit-number-container invoiced--title">{{ 'dashboard.unitsDashboard.Invoiced' | blah }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let unit">
                        <span class="unit-number-container">{{ unit.InvoicedAmount || 0 | number:'1.3-3' }}</span>
                    </mat-cell>
                </ng-container>

                <!-- aprice column -->
                <ng-container matColumnDef="aprice">
                    <mat-header-cell *matHeaderCellDef>
                        <span class="unit-number-container">{{ 'dashboard.unitsDashboard.Aprice' | blah }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let unit">
                        <span class="unit-number-container">{{ unit.UnitPrice || 0 | number:'1.2-2' }}</span>
                    </mat-cell>
                </ng-container>

                <!-- amounts column -->
                <ng-container matColumnDef="amounts">
                    <mat-header-cell *matHeaderCellDef>
                        {{ 'dashboard.unitsDashboard.Amounts' | blah }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let unit">
                        <div class="amounts-box__container">
                            <div class="amount-values__container">
                                <div>{{ (unit.UnitPrice * unit.OrderedAmount) || 0 | number:'1.2-2' }}</div>
                                <div>{{ (unit.UnitPrice * unit.SuppliedAmount) || 0 | number:'1.2-2' }}</div>
                                <div>{{ (unit.UnitPrice * unit.InvoicedAmount) || 0 | number:'1.2-2' }}</div>
                            </div>
                            <div class="amount-bars__container">
                                <ng-container *ngTemplateOutlet="amountBars; context: { unit: unit }"></ng-container>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <!-- invoicingForSupplied column -->
                <ng-container matColumnDef="invoicingForSupplied">
                    <mat-header-cell *matHeaderCellDef>
                        <span class="unit-number-container">{{ 'dashboard.unitsDashboard.InvoicingForSupplied' | blah }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let unit">
                        <span class="unit-number-container heading-17">
                            {{ (unit.InvoicedAmount * 100 / unit.SuppliedAmount) || 0 | number:'1.2-2' }}%
                        </span>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['groupHeader']; when: isSubheading"
                    [ngClass]="'table-list-group-header-row'"></mat-row>
                <mat-row *matRowDef="let row; columns: displayedColumns; let i = dataIndex"
                    [ngClass]="{'units-table-data-row': true, 'mat-row-even': i % 2 == 0}"></mat-row>
            </mat-table>
        </div>
    </div>
    }
    @else {
    <hpo-placeholder type="row"></hpo-placeholder>
    <hpo-placeholder type="row"></hpo-placeholder>
    <hpo-placeholder type="row"></hpo-placeholder>
    }
</mat-dialog-content>
<div mat-dialog-actions
    align="end">
    <hpo-button (click)="closeDialog()">
        {{ 'layout.close' | blah }}
    </hpo-button>
</div>

<!-- amountBar -->
<ng-template #amountBars
    let-unit="unit">
    @for (category of ['Ordered', 'Supplied', 'Invoiced']; track category) {
    <div class="bar__container">
        <div class="bar"
            [ngStyle]="getAmountBarStyles(unit, category)">
        </div>
    </div>
    }
</ng-template>